module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"notice1":"Для пополнения криптовалютных счетов BTC и ETH прямыми переводами необходимо пройти верификацию в разделе {link}. Пополнение USDT и USDC доступны уже сейчас."},"en":{"Повышение статуса":"Profile update","notice1":"To top up BTC and ETH crypto accounts with direct transfers, you need to pass verification in the {link} section. USDT and USDC top-ups are available now."}}')
  delete Component.options._Ctor
}
